import { useMemo } from 'react'

import {
  AvatarNameSelectorDocument,
  type AvatarNameSelectorQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export interface Employee {
  label: string
  value: number
}

export const useEmployees = (): {
  employees: Employee[]
  loading: boolean
  error?: unknown
} => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(AvatarNameSelectorDocument, {
    skip: !company || company.id == null,
    variables: {
      companyId: Number(company.id),
      active: false,
    },
    fetchPolicy: 'cache-and-network',
  })

  const items = useMemo<NonNullable<AvatarNameSelectorQuery['employees']>['employeeNames']>(
    () => data?.employees?.employeeNames ?? [],
    [data?.employees?.employeeNames]
  )

  const employees = useMemo<Employee[]>(() => {
    return items.map((node) => ({
      label: node.fullName ?? [node.firstName, node.lastName].filter(Boolean).join(' '),
      value: Number(node.id),
    }))
  }, [items])

  return { employees, loading, error }
}
